var list_items = [];

function itemSelectedMore(item){
    var qty_selected = 0;
  	var variant = [];
  
  	var opt_index =  $(item).data("opt-index");
  	var opt_size =  $(item).data("opt-size");
    var product =  $(item).data("product");
    var subProduct = $(".subproduct-"+product);
    var ItemsubProduct = $(".subproduct-"+product).closest(".item_subproduct");
    //console.log(opt_index);
  
    if(opt_index == 0){
		subProduct.find('input[data-opt-index=1]').prop("checked",false);
      	subProduct.find('input[data-opt-index=2]').prop("checked",false);
    }
  
  	if(opt_index == 1){
		subProduct.find('input[data-opt-index=2]').prop("checked",false);
    }

    var option1 = subProduct.find('input:checked').eq(0).data("value-handle");
    var option2 = subProduct.find('input:checked').eq(1).data("value-handle") || '';
    var option3 = subProduct.find('input:checked').eq(2).data("value-handle") || '';
    
    if(product !== undefined){
        if(opt_index == 0){
            if(opt_size > 1){
              	ItemsubProduct.find(".sw_el[data-opt-index=1]").css({"pointer-events": "auto","opacity": 1});
                ItemsubProduct.find(".sw_el[data-opt-index=1] label").css("opacity",1);              
                
                if(opt_size > 2){
                      ItemsubProduct.find(".sw_el[data-opt-index=2]").css({"pointer-events": "none","opacity": 0.5});
                      ItemsubProduct.find(".sw_el[data-opt-index=2] label").css("opacity",0.5);
                }               
              	
              	LISTVAR.forEach(scanArray1);
                function scanArray1(el, index) {
                    if(el.product == product && el.opt1 == option1 && el.stock == "false"){
                      	var temptopt2 = el.opt2;
                      
                      	ItemsubProduct.find(".sw_el[data-opt-index=1][data-value-handle="+temptopt2+"]").css({"pointer-events": "none","opacity": 0.5});
                        ItemsubProduct.find(".sw_el[data-opt-index=1][data-value-handle="+temptopt2+"] label").css("opacity",0.5);
                      	                
                    }
                }
              	
              	for(var x=0; x < LISTOPT2.length; x++){
                    var valid = false;
                  	var temptopt2 = LISTOPT2[x].opt2;
                  
                    LISTVAR.forEach(scanOpt2);                	                  
                    function scanOpt2(el, index) {
                      	
                        if(el.opt2 == LISTOPT2[x].opt2){
                            if(el.product == product && el.opt1 == option1 && el.stock == "true"){
                                valid = true;
                            }
                        }   
                    }

                    if(valid == false){    
                      	ItemsubProduct.find(".sw_el[data-opt-index=1][data-value-handle="+temptopt2+"]").css({"pointer-events": "none","opacity": 0.5});
                      	ItemsubProduct.find(".sw_el[data-opt-index=1][data-value-handle="+temptopt2+"] label").css("opacity",0.5);                                    
                    }else{
                    	ItemsubProduct.find(".sw_el[data-opt-index=1][data-value-handle="+temptopt2+"]").css({"pointer-events": "auto","opacity": 1});
                      	ItemsubProduct.find(".sw_el[data-opt-index=1][data-value-handle="+temptopt2+"] label").css("opacity",1);
                    }
                }
            }
        }

        if(opt_index ==  1){
            if(opt_size > 2){
              ItemsubProduct.find(".sw_el[data-opt-index=2]").css({"pointer-events": "auto","opacity": 1});
              ItemsubProduct.find(".sw_el[data-opt-index=2] label").css("opacity",1);
              
              LISTVAR.forEach(scanArray1);
              function scanArray1(el, index) {
                  if(el.product == product && el.opt1 == option1 && el.opt2 == option2 && el.stock == "false"){
                    var temptopt3 = el.opt3;
                    
                    ItemsubProduct.find(".sw_el[data-opt-index=2][data-value-handle="+temptopt3+"]").css({"pointer-events": "none","opacity": 0.5});
              		ItemsubProduct.find(".sw_el[data-opt-index=2][data-value-handle="+temptopt3+"] label").css("opacity",0.5);
                  }
              }             
              
              for(var x=0; x < LISTOPT3.length; x++){
                  var valid = false;
                  var temptopt3 = LISTOPT3[x].opt3;
                
                  LISTVAR.forEach(scanOpt3);            
                  function scanOpt3(el, index) {
                      if(el.opt3 == LISTOPT3[x].opt3){
                          if(el.product == product && el.opt1 == option1 && el.opt2 == option2 && el.stock == "true"){
                              valid = true;
                          }
                      }   
                  }

                  if(valid == false){  
                    ItemsubProduct.find(".sw_el[data-opt-index=2][data-value-handle="+temptopt3+"]").css({"pointer-events": "none","opacity": 0.5});
                    ItemsubProduct.find(".sw_el[data-opt-index=2][data-value-handle="+temptopt3+"] label").css("opacity",0.5);                                        
                  }else{
                  	ItemsubProduct.find(".sw_el[data-opt-index=2][data-value-handle="+temptopt3+"]").css({"pointer-events": "auto","opacity": 1});
                    ItemsubProduct.find(".sw_el[data-opt-index=2][data-value-handle="+temptopt3+"] label").css("opacity",1);  
                  }
              }              
            }
        }
      
        if(opt_size == 1){
			if (option1){
                LISTVAR.forEach(scanVariant);
                function scanVariant(obj, index) {
                    if(obj.product == product && obj.opt1 == option1 && obj.stock == "true"){
                        variant = obj;
                        qty_selected = 1;
                    } 
                }
            }
        }else if(opt_size == 2){
        	if (option1 && option2){
                LISTVAR.forEach(scanVariant);
                function scanVariant(obj, index) {
                    if(obj.product == product && obj.opt1 == option1 && obj.opt2 == option2 && obj.stock == "true"){
                        variant = obj;
                        qty_selected = 1;
                    } 
                }
            }
        }else{
        	if (option1 && option2 && option3){
                LISTVAR.forEach(scanVariant);
                function scanVariant(obj, index) {
                    if(obj.product == product && obj.opt1 == option1 && obj.opt2 == option2 && obj.opt3 == option3 && obj.stock == "true"){
                        variant = obj;
                        qty_selected = 1;
                    } 
                }
            }
        }
        
      
      	if(qty_selected < 0 || qty_selected === undefined || qty_selected === NaN){
                qty_selected = 0;
        }
        
        if(qty_selected > 0  ){
                $(ItemsubProduct).find(".div_bundle_button button").attr("disabled",false);
                var el_input = $(ItemsubProduct).find(".quantity-wrapper input");
              	var el_qty = $(ItemsubProduct).find(".val-qty-selected");         
              	$(el_qty).data("var_id", variant.id)                        
                generatePrice(el_input);
       	}else{
                $(ItemsubProduct).find(".div_bundle_button button").attr("disabled",true);
          		$(ItemsubProduct).find(".qty-selected").text("Items Selected : "+qty_selected);
                var el_price = $(ItemsubProduct).find(".price_total-selected");
                $(el_price).text("€0.00");
       	}  
    }
}

$(document).on("click", ".div_bundle_button button", function(){
  var ItemsubProduct = $(this).closest(".item_subproduct");
  var el_qty = $(ItemsubProduct).find(".val-qty-selected");
  var qty = $(el_qty).val()*1;
  var id = $(el_qty).data("var_id");
  
  if(qty > 0 && qty !== undefined){
    var id = parseInt(id);
    list_items.push({"id":id,"quantity":(qty)});
    Shopify.theme.ajaxCart.addItem(id,list_items);
    setTimeout(function(){
      window.PXUTheme.jsAjaxCart.updateView();
      console.log("ok");
    }, 1000);

    $(ItemsubProduct).find("input[type=radio]").prop("checked", false);
    $(ItemsubProduct).find(".sw_el[data-opt-index=1]").css({"pointer-events": "none","opacity": 0.5});
    $(ItemsubProduct).find(".sw_el[data-opt-index=2]").css({"pointer-events": "none","opacity": 0.5});
    $(ItemsubProduct).find(".val-qty-selected").val(0);
    $(ItemsubProduct).find(".qty-selected").text("Items Selected : 0");
    $(ItemsubProduct).find(".price_total-selected").text("€0.00");

    list_items = [];
  }
});

function generatePrice(el){
    setTimeout(function(){ 
        var el_price = $(el).closest(".item_subproduct").find(".price_total-selected");
        var el_qty = $(el).closest(".item_subproduct").find(".val-qty-selected");
        var qty = $(el).val()*1;
        var price = ($(el).data("vr_price")*1)/100;
        $(el_qty).val(qty);
      	
        if(qty > 0 && qty !== undefined){
          	var subtotal = (Math.round((price * 100)*qty) / 100).toFixed(2);
          	$(el).closest(".item_subproduct").find(".qty-selected").text("Items Selected : "+qty);
			$(el_price).text("€"+subtotal);
        }
    }, 500);   	
}

$(".qty_bundle .quantity-plus").bind('keyup mouseup', function () {
    var el = $(this).closest(".quantity-wrapper").find("input");
	generatePrice(el);       
});

$(".qty_bundle .quantity-minus").bind('keyup mouseup', function () {
    var el = $(this).closest(".quantity-wrapper").find("input");
	generatePrice(el);       
});
 
function removeDuplicate(){
  	var templist1 = [];
    LISTOPT1.forEach(scanArray1);
    function scanArray1(el, index) {
        if(templist1.length == 0){
            templist1.push(el);
        }else{
          var check = false;
          for(var x = 0; x < templist1.length; x++){
              if(templist1[x].opt1 == el.opt1){
                  check = true;
               }
          }
          if(check == false){
              templist1.push(el);
          }
        }   
    }
    LISTOPT1 = templist1;
  
    var templist2 = [];
    LISTOPT2.forEach(scanArray2);
    function scanArray2(el, index) {
        if(templist2.length == 0){
            templist2.push(el);
        }else{
          var check = false;
          for(var x = 0; x < templist2.length; x++){
              if(templist2[x].opt2 == el.opt2){
                  check = true;
               }
          }
          if(check == false){
              templist2.push(el);
          }
        }   
    }
    LISTOPT2 = templist2;

    var templist3 = [];
    LISTOPT3.forEach(scanArray3);
    function scanArray3(el, index) {
        if(templist3.length == 0){
            templist3.push(el);
        }else{
          var check = false;
          for(var x = 0; x < templist3.length; x++){
              if(templist3[x].opt3 == el.opt3){
                  check = true;
               }
          }
          if(check == false){
              templist3.push(el);
          }
        }   
    }
    LISTOPT3 = templist3;
}

function checkFirstOption(){
	var item_el = $(".item_subproduct");
    for(var i=0; i < item_el.length; i++){
		var sw_el = $(item_el[i]).find(".sw_el[data-opt-index=0]").eq(0);
      
        if($(sw_el).data("opt-size") == 1){
          var product =  $(sw_el).data("product");
          var pr_target = 0;
          
          for(var x=0; x < LISTOPT1.length; x++){
                var valid = true;
            	var temptopt1 = LISTOPT1[x].opt1;
            
                LISTVAR.forEach(scanOpt1);                  
                function scanOpt1(el, index) {
                   if(el.opt1 == LISTOPT1[x].opt1){
                      if(el.product == product && el.stock == "false"){
                         valid = false;
                         pr_target = 1;
                      }
                   }   
                }

                if(valid == false && pr_target == 1){     
                    $(item_el[i]).find(".sw_el[data-opt-index=0][data-value-handle="+temptopt1+"]").css({"pointer-events": "none","opacity": 0.5});
                    $(item_el[i]).find(".sw_el[data-opt-index=0][data-value-handle="+temptopt1+"] label").css("opacity",0.5);   
                }
           }
        }
    }
}

$( document ).ready(function() {
    setTimeout(function(){ $(".div_bundle_button button").attr("disabled",true);}, 1000); 
    removeDuplicate();
  	checkFirstOption();
  
    $(".sw_el[data-opt-index=1]").css({"pointer-events": "none","opacity": 0.5});
    $(".sw_el[data-opt-index=2]").css({"pointer-events": "none","opacity": 0.5});
});